import { ALLOW_ORDER_SUCCESS } from '@/constants/order'
import { isNativeShellApp } from '@/utils/appBridgeGate'

export default defineNuxtRouteMiddleware(() => {
  if (!process.client) return

  const allow = sessionStorage.getItem(ALLOW_ORDER_SUCCESS)
  const partnersKey = useRoute().params.partner

  if (allow !== 'true') {
    if (isNativeShellApp()) {
      // 2.2.7 이상: 네이티브 홈으로 복귀
      window.flutter_inappwebview?.callHandler('openNativeScreen', {
        screen: 'home'
      })
      return abortNavigation()
    }

    // 2.2.6 이하 / 일반 브라우저: 안내 후 웹 홈 이동
    alert('비정상적인 접근입니다. 메인으로 이동합니다.')
    window.location.href = partnersKey ? `/partners/${partnersKey}` : '/'
    return
  }
})
